export const ENGLISH_CODE = 'en';

export const LANG_PARAM = 'lang';
